'use strict';

import { ref } from 'vue';
import { defineStore } from 'pinia';

/**
 * Pinia store for a toasts
 */
export const useToastStore = defineStore('toast', () => {
  /**
   * Toast open
   */
  const open = ref(false);

  /**
   * Toast type
   */
  const type = ref('text-bg-primary');

  /**
   * Toast type
   */
  const message = ref('');

  /**
   * Success toast
   * @param {String} value - message to display
   * @returns {void}
   */
  const success = (value) => {
    type.value = 'text-bg-success';
    message.value = value;
    open.value = true;
  };

  /**
   * Error toast
   * @param {String} value - message to display
   * @returns {void}
   */
  const error = (value) => {
    type.value = 'text-bg-danger';
    message.value = value;
    open.value = true;
  };

  /**
   * Hide toast
   * @param {String} value - message to display
   * @returns {void}
   */
  const hide = () => {
    type.value = '';
    message.value = '';
    open.value = false;
  };

  return {
    open,
    type,
    message,
    success,
    error,
    hide,
  };
});
